import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20soft%20flowing%20gradient%20in%20warm%20coral%20and%20peach%20tones%2C%20gentle%20organic%20shapes%2C%20dreamy%20atmosphere%2C%20minimalist%20artistic%20texture%2C%20elegant%20and%20warm&width=1600&height=600&seq=cta-bg-home&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/70 to-primary-800/40"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-white mb-4">
          准备好开启自我探索之旅了吗？
        </h2>
        <p className="text-white/80 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed">
          每一篇文章都是我们用心编写的科学知识，帮助你在安全、舒适的认知框架中了解自己的身体。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/xingjiankang-kepu"
            className="px-7 py-3 rounded-full bg-background-50 text-primary-700 text-sm font-medium hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            浏览科普文章
          </Link>
          <Link
            to="/about"
            className="px-7 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white border border-white/30 text-sm font-medium hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer"
          >
            了解{siteConfig.name}
          </Link>
        </div>
      </div>
    </section>
  );
}